export default __webpack_public_path__ + "static/media/projectThumb5.c50e40e8.png";